export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أمس"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["دردشة"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اليوم"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الاثنين"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الثلاثاء"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الأربعاء"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الخميس"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الجمعة"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["السبت"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الأحد"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يناير"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["فبراير"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مارس"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أبريل"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مايو"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يونيو"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يوليو"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أغسطس"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سبتمبر"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أكتوبر"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نوفمبر"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ديسمبر"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أنت"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مسؤول"])}
}